import { AppContext } from "./appContext";
import { useEffect, useState } from "react";



function AppState(props) {


    const [colorSettings, setColorSettings] = useState(null);
    const [userData, setUserData] = useState({

        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
        customer: localStorage.getItem('customer') ? localStorage.getItem('customer') : '',
        user: localStorage.getItem('user') ? localStorage.getItem('user') : '',
        userSession: localStorage.getItem('UserSession') ? localStorage.getItem('UserSession') : '',
    })
  const [language, setLanguage] = useState("en"); // 'en' or 'mr'

  useEffect(() => {
    // Get the current domain origin (e.g., https://ai.wifiattendance.com)
    // const currentDomain = window.location.origin;
    // const currentDomain ="https://ai.wifiattendance.com";
    const currentDomain ="https://www.vehicletracking.qa";

    // const currentDomain ="https://aiassistant.lywo.in/";

    // Define the API endpoint with dynamic domain
    const apiUrl = `https://cloudxperte.crm-api.wifiattendance.com:3016/api/GetColorSettingsByDomain?domain=${currentDomain}`;

    // Fetch the data from the API
    fetch(apiUrl)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then((data) => {
            setColorSettings(data);
            localStorage.setItem("ColorTheme", JSON.stringify(data));
        })
        .catch((error) => {
            // Handle the error silently or log it
            // console.error("Error fetching theme:", error);
        });
}, []);



    return (
        <AppContext.Provider value={{
            colorSettings: colorSettings,
            userData,
            setUserData,
            language, setLanguage
        }}
        >
            {props.children}
        </AppContext.Provider>)

}

export default AppState